import { OcasiaoBrinde } from '../generated/backend-enums.js';
export { OcasiaoBrinde };
export const OcasiaoBrindeMap = {
    [OcasiaoBrinde.ANIVERSARIO]: 'Aniversário',
    [OcasiaoBrinde.DIA_DAS_MAES]: 'Dia das Mães',
    [OcasiaoBrinde.DIA_DOS_PAIS]: 'Dia dos Pais',
    [OcasiaoBrinde.NATAL]: 'Natal',
    [OcasiaoBrinde.OUTRA]: 'Outra ocasião',
};
